// **********************************************************
//  specialists-slider
// **********************************************************
/* eslint-disable */
$(function () {
  new Swiper('.patient-testimonials', {
    slidesPerView: 'auto',
    spaceBetween: 25,
    autoplay: {
      delay: 7000,
    },
    freeMode: true,
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 32,
      }
    },
  });
});
/* eslint-enable */
